/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_CInputs */



/**
* | output |
* | --- |
* | "Program C" |
*
* @param {Subtitle_Export_Program_CInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_c = /** @type {((inputs?: Subtitle_Export_Program_CInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_CInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Programme C")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programm C")
	if (locale === "it") return /** @type {LocalizedString} */ ("Programma C")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Программа C")
	if (locale === "es") return /** @type {LocalizedString} */ ("Programa C")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("程序C")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラムC")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम सी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Programa C")
	return /** @type {LocalizedString} */ ("Program C")
});